<template>
  <div>
    <v-layout v-if="componentLoading" row wrap justify-center>
      <v-progress-circular :size="64" :width="3" indeterminate color="primary" />
    </v-layout>
    <div v-else>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card id="invitesTableContent" class="max-shadow">
            <v-card-title class="pa-1">
              <v-toolbar flat color="white" height="48">
                <v-spacer />
                <v-spacer />
                <v-toolbar-items>
                  <search-widget v-model="search" />
                  <date-picker v-model="selectedDate" type="date" />
                  <template v-if="profile.role !== 'admin'">
                    <v-btn :to="`invites/add`" color="primary" flat>add</v-btn>
                    <v-btn :to="`invites/bulk-invite`" color="primary" flat>bulk invite</v-btn>
                  </template>
                </v-toolbar-items>
              </v-toolbar>
            </v-card-title>
            <v-flex xs12>
              <v-data-table
                id="invitesTable"
                :headers="invitesHeaders"
                :items="invites"
                :search="search"
                :loading="progressBar"
                :rows-per-page-items="[5,10,25,50]"
                :pagination.sync="pagination"
                item-key="id"
                no-data-text="No invites yet"
                class="px-2 pb-2"
                disable-initial-sort
              >
                <v-progress-linear slot="progress" color="primary" indeterminate />
                <template slot="items" slot-scope="props">
                  <tr class="row-border" @click="$router.push(`invites/${props.item.id}`)">
                    <td class="tablePadding" style="width: 20px">{{ getIndex(props.index + 1) }}</td>
                    <td class="text-xs-left tablePadding" style="width: 40px">
                      <avatar :size="40" :text="props.item.name" :src="props.item.photoUri" />
                    </td>
                    <td class="text-xs-left tablePadding">{{ props.item.name }}</td>
                    <td class="text-xs-left tablePadding">{{ props.item.visitorType }}</td>
                    <template v-if="profile.role !== 'employee'">
                      <td class="text-xs-left tablePadding">{{ getHostName(props.item.host) }}</td>
                      <td class="text-xs-left tablePadding">{{ props.item.createdBy.name }}</td>
                    </template>
                    <td class="text-xs-left tablePadding">{{ formatDate(props.item.expectedAt) }}</td>
                    <td
                      class="text-xs-left tablePadding"
                    >{{ getStatusText(props.item.used, props.item.expiresAt) }}</td>
                    <template v-if="profile.role !== 'employee'">
                      <td class="text-xs-left tablePadding">
                        <v-menu offset-y left @click.native.stop>
                          <v-btn slot="activator" icon>
                            <v-icon color="iconColor">more_vert</v-icon>
                          </v-btn>
                          <v-list>
                            <template v-for="item in actions">
                              <v-list-tile
                                v-if="shouldHide(item, props.item)"
                                :key="item.text"
                                @click="doAction(item.action, props.item)"
                              >
                                <v-list-tile-title>
                                  <v-icon>{{ item.icon }}</v-icon>
                                  {{ item.title }}
                                </v-list-tile-title>
                              </v-list-tile>
                            </template>
                          </v-list>
                        </v-menu>
                      </td>
                    </template>
                  </tr>
                </template>
                <template slot="no-results">
                  <p class="text-xs-center">
                    Your search for
                    <span class="font-weight-bold subheading">{{ search }}</span> found no results.
                  </p>
                </template>
              </v-data-table>
            </v-flex>
          </v-card>
        </v-flex>
        <v-flex>
          <inviteLogChart />
        </v-flex>
        <v-dialog v-model="deleteInviteDialog" lazy max-width="600px">
          <v-card class="max-shadow">
            <v-card-title primary-title>
              <div class="headline">Delete {{ selectedItem.name }}</div>
            </v-card-title>
            <v-card-text>
              <div class="subheading">
                Do you want to delete
                <strong>{{ selectedItem.name }}</strong>'s invite?
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn flat color="primary" @click.stop="deleteInviteDialog = false">Cancel</v-btn>
              <v-btn flat color="primary" @click.stop="confirmDeleteInvite">Delete</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="0" bottom>
          {{ snackbarMessage }}
          <v-btn flat @click.native="snackbar = false">Close</v-btn>
        </v-snackbar>
      </v-layout>
    </div>
  </div>
</template>
<script>
import DatePicker from '@/components/common/DatePicker';
import inviteLogChart from '@/components/max-admin/vms/invites/InviteLogChart';
import avatar from '@/components/common/Avatar';
import SearchWidget from '@/components/common/SearchWidget';
import * as moment from 'moment';
import _get from 'lodash/get';
import { database } from '@/firebase';

export default {
  name: 'InvitesTable',
  components: {
    'date-picker': DatePicker,
    avatar,
    'search-widget': SearchWidget,
    inviteLogChart
  },
  data() {
    return {
      componentLoading: true,
      deleteInviteDialog: false,
      progressBar: true,
      firebaseListeners: [],
      dateFormat: 'YYYY-MM-DD',
      selectedDate: '',
      startAt: '',
      endAt: '',
      search: '',
      pagination: {
        rowsPerPage: 10
      },
      invites: [],
      selectedItem: {},
      menuSlot: '',
      actions: [
        {
          title: 'Check In',
          icon: '',
          action: 'checkIn'
        },
        {
          title: 'Delete',
          icon: '',
          action: 'delete'
        }
      ],
      invitesHeaders: [
        {
          text: '#',
          value: false,
          align: 'left',
          width: '10px',
          class: ['tablePadding']
        },
        {
          text: 'Photo',
          value: 'photo',
          align: 'left',
          class: ['tablePadding']
        },
        {
          text: 'Name',
          value: 'name',
          align: 'left',
          class: ['tablePadding']
        },
        {
          text: 'Purpose',
          value: 'visitorType',
          align: 'left',
          class: ['tablePadding']
        },
        {
          text: 'Host',
          value: 'hostName',
          align: 'left',
          class: ['tablePadding']
        },
        {
          text: 'Created By',
          value: 'createdByName',
          align: 'left',
          class: ['tablePadding']
        },
        {
          text: 'Expected At',
          value: 'expectedAt',
          align: 'left',
          class: ['tablePadding']
        },
        {
          text: 'Status',
          value: 'status',
          align: 'left',
          class: ['tablePadding']
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
          class: ['tablePadding']
        }
      ],
      snackbarMessage: '',
      snackbarColor: 'primary',
      snackbar: false
    };
  },
  computed: {
    locationId() {
      return _get(this.$store.state.VMS, 'lid');
    },
    profile() {
      return _get(this.$store.state, 'profile');
    },
    inviteRef() {
      const lid = _get(this.$store.state.VMS, 'lid');
      const role = _get(this.$store.state.profile, 'role');
      const cid = _get(this.$store.state.profile, 'cid');
      // return null if the location ID is not yet set
      if (!lid) return null;
      if (role === 'admin')
        return database.ref(`vms/${lid}/tenants_data/${cid}/invites`);

      return database.ref(`vms/${lid}/invites`);
    }
  },
  watch: {
    inviteRef: {
      handler(val) {
        if (!val) return;

        this.firebaseListeners.forEach(listenerFunc => {
          val.off('value', listenerFunc);
        });

        this.fetchInvites();
      },
      immediate: true
    },
    selectedDate: {
      handler(val) {
        this.startAt = moment(val)
          .startOf('day')
          .toISOString();
        this.endAt = moment(val)
          .endOf('day')
          .toISOString();
        if (!this.inviteRef) return;
        this.firebaseListeners.forEach(listenerFunc => {
          this.inviteRef.off('value', listenerFunc);
        });
        this.fetchInvites();
      }
    },
    profile: {
      handler(val) {
        if (!val || !this.invitesHeaders) return;
        if (val.role === 'employee') {
          const { invitesHeaders } = this;
          const actionFiltered = invitesHeaders.filter(
            obj =>
              obj.value !== 'actions' &&
              obj.value !== 'hostName' &&
              obj.value !== 'createdByName'
          );
          this.invitesHeaders = actionFiltered;
        }
      },
      immediate: true
    }
  },
  created() {
    this.selectedDate = moment().format(this.dateFormat);
    this.startAt = moment()
      .startOf('day')
      .toISOString();
    this.endAt = moment()
      .endOf('day')
      .toISOString();
    this.componentLoading = false;
  },
  beforeDestroy() {
    this.firebaseListeners.forEach(listenerFunc => {
      this.inviteRef.off('value', listenerFunc);
    });
  },
  methods: {
    fetchInvites() {
      const invitesQuery = this.inviteRef
        .orderByChild('expectedAt')
        .startAt(this.startAt)
        .endAt(this.endAt)
        .on('value', invitesSnapshot => {
          if (invitesSnapshot) {
            const log = invitesSnapshot.val();
            const invitesArray = this._toArray(log);
            // console.log(invitesArray);
            this.invites = invitesArray;
            this.progressBar = false;
          }
        });
      this.firebaseListeners.push(invitesQuery);
    },
    _toArray(obj) {
      if (!obj) return [];
      return Object.keys(obj).map(key => {
        const item = obj[key];
        item.id = key;
        return item;
      });
    },
    formatDate(ISOString) {
      if (ISOString) {
        return moment(ISOString).format('h:mm A');
      }
      return '';
    },

    getIndex(index) {
      const { page, rowsPerPage } = this.pagination;
      return index + (page - 1) * rowsPerPage;
    },
    getStatusText(used, date) {
      if (date !== undefined) {
        const checkExpiry = moment(moment().toISOString()).isSameOrAfter(date);
        if (used) {
          return 'CheckedIn';
        } else if (used === undefined && checkExpiry) {
          return 'Expired';
        }
        return 'Expected';
      }
      return 'Expected';
    },
    getHostName(host) {
      return host ? host.name : '';
    },
    shouldHide(action, item) {
      if (action.title === 'Check In') {
        if (
          item.used ||
          moment(moment().toISOString()).isSameOrAfter(item.expiresAt)
        )
          return false;
        return true;
      }
      return true;
    },
    doAction(actionName, item) {
      if (actionName === 'delete') {
        this.deleteInvite(item);
      } else if (actionName === 'checkIn') {
        this.checkIn(item);
      }
    },
    deleteInvite(item) {
      this.selectedItem = item;
      this.deleteInviteDialog = true;
    },
    checkIn(item) {
      const path = `vms/${this.locationId}`;
      const logRef = database.ref(`${path}/visitor_log/`).push();
      const { key } = logRef;
      // eslint-disable-next-line
      item.used = true;
      const invite = Object.assign({ logId: key }, item);
      // console.log(invite);
      const visitorEntry = {};
      visitorEntry.checkInDate = moment().toISOString();
      visitorEntry.company = item.company;
      visitorEntry.email = item.email;
      if (item.host) {
        visitorEntry.hostName = item.host.name;
        visitorEntry.hostEmail = item.host.email;
        visitorEntry.hostPhone = item.host.phone || '';
        visitorEntry.hostUid = item.host.uid;
      }
      if (item.fields) {
        visitorEntry.fields = item.fields;
      }
      visitorEntry.iid = item.id;
      visitorEntry.name = item.name;
      visitorEntry.phone = item.phone;
      visitorEntry.photoUri = item.photoUri;
      visitorEntry.visitorType = item.visitorType;
      visitorEntry.visitorTypeKey = item.visitorTypeKey;
      const inviteRef = database.ref(`${path}/invites/${item.id}`);
      const visitorLogRef = database.ref(`${path}/visitor_log/${key}`);
      Promise.all([inviteRef.update(invite), visitorLogRef.set(visitorEntry)]);
    },
    confirmDeleteInvite() {
      const invite = this.selectedItem;
      this.deleteInviteDialog = false;
      this.inviteRef
        .child(`${invite.id}`)
        .set(null)
        .catch(error => {
          this.snackbarMessage = error;
          this.snackbarColor = 'error';
          this.snackbar = true;
        });
    }
  }
};
</script>
<style>
div#invitesTableContent {
  height: calc(100vh - var(--toolbar-height));
}
#invitesTable .v-table__overflow {
  height: calc(100vh - var(--pagination-height));
  overflow-y: scroll;
  overflow-x: visible;
}
</style>

